import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { SLEEPING_ARRANGEMENTS } from "../../../utils/default-strings";
import { buildKeyFromStrings } from "../../../utils/build-key-from-strings";
import { Heading } from "../../typography/Heading";
import { IconCard } from "../../elements/IconCard";
export var Component = function Component(_ref) {
  var headingText = _ref.headingText,
      sleepingArrangements = _ref.sleepingArrangements;
  return React.createElement(Fragment, null, React.createElement(Heading, null, headingText), sleepingArrangements.map(function (_ref2, index) {
    var iconName = _ref2.iconName,
        label = _ref2.label;
    return React.createElement(IconCard, {
      isLeftAligned: true,
      key: buildKeyFromStrings(label, index),
      label: label,
      name: iconName,
      size: "large"
    });
  }));
};
Component.displayName = 'SleepingArrangements';
Component.defaultProps = {
  headingText: SLEEPING_ARRANGEMENTS
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  headingText: PropTypes.string,
  sleepingArrangements: PropTypes.arrayOf(PropTypes.shape({
    iconName: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired
} : {};